module.exports = __webpack_public_path__ + "img/stock0.df57fff1.png";